export const TelecallerMenuList = [
    {
        title: "Leads",
        iconStyle: imagepaths.AdminLeadsIconWhite,
        iconActive: imagepaths.AdminLeadsIconWhiteActive,
        to: "/app/leads",
        id: "leads",
    },
    {
        title: "Assigned to Ops",
        iconStyle: imagepaths.FileIconWhite,
        iconActive: imagepaths.FileIconWhiteActive,
        to: "/app/opsleads",
        id: ["opsleads"],
    },
    {
        title: "Policies",
        iconStyle: imagepaths.shieldIconWhite,
        iconActive: imagepaths.shieldIconWhiteActive,
        to: "/app/connectorhome",
        id: ["dataPrivacyModal", "dataStorageModal", "rbipolicy"],
        classChange: "mm-collapse",
        content: [
            {
                title: "Privacy Policy",
                iconStyle: imagepaths.PrivacyPolicyWhite,
                iconActive: imagepaths.PrivacyPolicyWhiteActive,
                to: "/app/connectorhome",
                classChange: "menu-popup",
                id: "dataPrivacyModal",
                showTitle: true
            },
            {
                title: "Terms and Conditions",
                iconStyle: imagepaths.MasterDataIconWhite,
                iconActive: imagepaths.MasterDataIconWhiteActive,
                to: "/app/connectorhome",
                classChange: "menu-popup",
                id: "dataStorageModal",
            }
        ],
    },
];
